import React from "react";
import { Container, Flex, useColorModeValue } from "@chakra-ui/react";
import Navbar from "../components/Navbar";
import Header from "../components/Header";
import ImageUploadComponent from "../components/ImageUploadComponent";

const PartialBonyImpaction = () => {
    return (
        <>
            <Header />
            <Navbar />
            <Container
                bgColor={useColorModeValue("gray.200", "blue.900")}
                maxW="full"
                mt={0}
                centerContent
                overflow="hidden"
                py={10}
            >
                <Flex direction="column" align="center" p={4}>
                    <ImageUploadComponent 
                        apiUrl={`${process.env.REACT_APP_MOUTH_API}/detect_with_output_img/partial_impacted_tooth_pa?threshold=0.35`} 
                        title={"ตรวจจับฟันคุดแบบจากภาพแบบ PA"} 
                        desc={"ตรวจจับได้เฉพาะฟันคุดแบบ Partial Partial Bony Impaction เท่านั้น"}
                    />
                </Flex>
            </Container>
        </>

    );
};

export default PartialBonyImpaction;
